import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';

const OrganisationAdminsService = ComposedComponent =>
  reduxFetch([
    {
      resource: 'organisationAdmins',
      method: 'get',
      request: id => ({
        url: apiRoutes.organisationAdmins(id),
      }),
    },
  ])(ComposedComponent);

export default OrganisationAdminsService;
